import { render, staticRenderFns } from "./PickUpRecord.vue?vue&type=template&id=a3c5a3f4&scoped=true"
import script from "./PickUpRecord.vue?vue&type=script&lang=js"
export * from "./PickUpRecord.vue?vue&type=script&lang=js"
import style0 from "./PickUpRecord.vue?vue&type=style&index=0&id=a3c5a3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c5a3f4",
  null
  
)

export default component.exports